// Unpublished Work © 2025 Deere & Company. All Worldwide Rights Reserved.

export const TOAST_TYPE = {
    INFO: 'info',
    WARN: 'warning',
    DEFAULT: 'default',
    SUCCESS: 'success',
    ERROR: 'error'
};
